


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, FetchUserApi, Toast } from "../../customHooks/customHooks";
import { CREATE_USERS_URl, DELETE_USERS_URl, GET_USER_URl, GET_USERS_URl, UPDATE_USERS_URl } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllUsers = createAsyncThunk('allUser', async (_, { rejectWithValue }) => {
    try {
        // simulate delay (2 seconds)
        await new Promise(resolve => setTimeout(resolve, 400));

        const response = await FetchData(GET_USERS_URl, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data;
            return { status: 200, data }; // return actual user data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.error("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});


// -- Slice --
const GetAllUserSlice = createSlice({
    name: 'User',
    initialState: {
        User: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllUsers.fulfilled, (state, action) => {
                state.User = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllUsers.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

// -- Async Thunk to Get User Profile --
export const GetSingleUser = createAsyncThunk('GetSingleUser', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(GET_USER_URl, { UserID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetSingleUserSlice = createSlice({
    name: 'SingleUser ',
    initialState: {
        User: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetSingleUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSingleUser.fulfilled, (state, action) => {
                state.User = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetSingleUser.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

export const CreateNewUser = createAsyncThunk('AddUser', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchUserApi(CREATE_USERS_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'User Created successfully.')
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateUser = createAsyncThunk('updateUser', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_USERS_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'User updated successfully.')

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteUser = createAsyncThunk('deleteUser', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_USERS_URl, { UserID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Role Deleted successfully.')

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export {
    GetAllUserSlice,
    GetSingleUserSlice
};
